import { Box, Grid } from "@mui/material";
import FormSection from "../../../../common/components/functional/formSection/FormSection";
import { useTranslation } from "react-i18next";
import { Union } from "../unionsApi";
import { StyledTextField } from "../unionsStyles";
import PhoneField from "../../../../common/components/functional/phoneField/PhoneField";
interface Props {
  union: Union;
  setUnion: (union: Union) => void;
}

const UnionFormBasicInfo = ({ union, setUnion }: Props) => {
  const { t } = useTranslation();

  return (
    <FormSection title={t("settings:unionBasicInfo")}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={4}>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            {t("settings:unionBusinessId")}
          </Box>
        </Grid>
        <Grid item xs={8}>
          <StyledTextField
            debounce={500}
            value={union?.businessId || ""}
            name="unionBusinessId"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              e.target.value.length <= 128 && // Max 128 characters
              setUnion({ ...union, businessId: e.target.value })
            }
          />
        </Grid>
        <Grid item xs={4}>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            {t("settings:unionPhone")}
          </Box>
        </Grid>
        <Grid item xs={8}>
          <Box sx={{ width: "50%" }}>
            <PhoneField
              value={union?.phoneNumber || ""}
              onChange={(newValue) =>
                setUnion({ ...union, phoneNumber: newValue })
              }
            />
          </Box>
        </Grid>
        <Grid item xs={4}>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            {t("settings:unionStreet")}
          </Box>
        </Grid>
        <Grid item xs={8}>
          <StyledTextField
            value={union?.address?.street || ""}
            name="unionStreet"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              e.target.value.length <= 512 && // Max 512 characters
              setUnion({
                ...union,
                address: { ...union.address, street: e.target.value },
              })
            }
          />
        </Grid>
        <Grid item xs={4}>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            {t("settings:unionPostalCode")}
          </Box>
        </Grid>
        <Grid item xs={8}>
          <StyledTextField
            value={union?.address?.zip || ""}
            name="unionPostalCode"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              (e.target.value === "" || /^\d+$/.test(e.target.value)) && // Numbers only
              e.target.value.length <= 64 && // Max 64 characters
              setUnion({
                ...union,
                address: { ...union.address, zip: e.target.value },
              })
            }
          />
        </Grid>
        <Grid item xs={4}>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            {t("settings:unionCity")}
          </Box>
        </Grid>
        <Grid item xs={8}>
          <StyledTextField
            value={union?.address?.city || ""}
            name="unionCity"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              e.target.value.length <= 128 && // Max 128 characters
              setUnion({
                ...union,
                address: { ...union.address, city: e.target.value },
              })
            }
          />
        </Grid>
      </Grid>
    </FormSection>
  );
};

export default UnionFormBasicInfo;
